enum AddToBagLayoutEnum {
	text = 'text',
	icon = 'icon'
}

export default AddToBagLayoutEnum;
